import React from 'react';
import './scss/no-results.scss';

const NoResults = (props) => {

  const clearFilters = (e) => {
    e.preventDefault();
    // Clear search input and filters.
    props.setFilters({
      audience: '',
      category: '',
      industry: '',
      search: null,
    });
  }

  return (
    <div className='no-results'>

      <div>
        <span>{Drupal.t('Sorry, I couldn\'t fetch any results. Try another search instead or ')}</span>
        <a href="#" onClick={clearFilters}>{Drupal.t('clear search & filters')}</a>.
      </div>

      <img alt='No results' className='img-responsive' src='/sites/default/files/inline-images/zero-results-eddie-desktop.png' loading='lazy'></img>
    </div>
  );
}

export default NoResults;